<template>
  <modal :show.sync="showModal" header-classes="justify-content-center" @close="handleClose()">
    <h4 slot="header" class="title title-up">
      Export List of Students
    </h4>
    <div
      class="text-center"
    >
      <h5>Level of Involvement</h5>
      <p>
        <b><i>
          All involvement data is as of {{ displayDate }} and, therefore, will only reflect involvement from this academic year.
        </i></b>
      </p>
      <el-radio v-model="csvType" label="bible-study-participants">
        Bible Study Participants
      </el-radio>
      <el-radio v-model="csvType" label="disciples">
        Disciples
      </el-radio>
      <el-radio v-model="csvType" label="all-contacts">
        All people added since {{ displayDate }}
      </el-radio>
    </div>
    <div
      class="text-center"
    >
      <h5>Only Varsity Catholic or Greek?</h5>
      <el-radio
        v-model="involveType"
        label="all-students"
        checked
      >
        All Students
      </el-radio>
      <el-radio v-model="involveType" label="only-vc">
        Only VC
      </el-radio>
      <el-radio v-model="involveType" label="only-greek">
        Only Greek
      </el-radio>
    </div>
    <p>
      <span v-if="validationError.csvType === true" style="color: red;">
        Please select which CSV type to download.<br>
      </span>
    </p>
    <p>
      <span v-if="validationError.involveType === true" style="color: red;">
        Please select All, VC, or Greek.<br>
      </span>
    </p>
    <template slot="footer">
      <i>May take up to 15 seconds</i>
      <p-button @click.native="handleClose">
        Close
      </p-button>
      <p-button type="danger" v-if="!saving" @click.native="handleSave">
        Export
      </p-button>
      <p-button type="danger" v-if="saving">
        Exporting...
      </p-button>
          &nbsp;&nbsp;
    </template>
  </modal>
</template>
<script>
import { mapState, mapActions, vuex } from 'vuex';
import Modal from '../UIComponents/Modal';
import { RepositoryFactory } from '../../repositories/repositoryFactory';

const PeopleRepository = RepositoryFactory.get('people');

function validateCsvType(csvType) {
    return !!csvType;
}

function validateInvolveType(involveType) {
    return !!involveType;
}

export default {
    name: 'DownloadCsvModal',
    components: {
        Modal
    },
    data() {
        return {
            showModal: false,
            saving: false,
            validationError: {
                csvType: false,
                involveType: false
            },
            csvType: '',
            involveType: '',
            displayDate: this.getDate()
        };
    },
    methods: {
        getDate() {
            const today = new Date();
            if (today.getMonth() < 7) {
                today.setFullYear(today.getFullYear() - 1);
            }
            today.setMonth(7);
            today.setDate(1);
            return today.toDateString().substring(3);
        },
        handleClose() {
            this.csvType = '';
            this.involveType = '';
            this.validationError.csvType = false;
            this.validationError.involveType = false;
            this.$emit('close');
        },
        handleSave() {
            this.saving = true;
            this.validationError.csvType = !validateCsvType(this.csvType);
            this.validationError.involveType = !validateInvolveType(this.involveType);
            this.$emit('save');
            if (this.validationError.csvType) {
                this.saving = false;
                return;
            }
            if (this.validationError.involveType) {
                this.saving = false;
                return;
            }
            PeopleRepository.csvExport(this.csvType, this.involveType)
                // Get csv back from backend
                .then((response) => {
                    this.saving = false;

                    // Download file from browser
                    const blob = new Blob([response.data], { type: 'application/csv' });
                    const url = window.URL.createObjectURL(blob);
                    const anchor = document.createElement('a');
                    anchor.download = 'student_contacts.csv';
                    anchor.href = url;
                    anchor.click();
                })
                .catch((error) => {
                    this.saving = false;
                    this.error = error.response.data.message;
                    this.$message(error.response.data.message);
                });
            this.$emit('save');
            // this.$emit('close'); If want to automatically close modal after download
            this.csvType = '';
            this.validationError.csvType = false;
            this.involveType = '';
            this.validationError.involveType = false;
        }
    },
    props: {
        show: Boolean,
    },
    watch: {
        show(val) {
            this.showModal = val;
            if (this.showModal === true) {
                // placeholder
            }
        }
    },
};

</script>
